export default "__VITE_ASSET__BJBWZZ8o__"